import React, { useState } from "react";
import {
  message,
  Form,
  AutoComplete,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Button,
} from "antd";
import ds from "../../Services/DataServices";
import { useSelector, useDispatch } from "react-redux";
// import Spinner from "reactstrap/lib/Spinner";
import {
  loadPaymentStatusModalShow,
  loadPaymentCloseWindow,
  loadPaymentStatusData,
} from "../../appRedux/actions/CommonData";
import PaymentStatusModal from "./PaymentStatusModal";
import { loadIsShowCompleteSale } from "../../appRedux/actions/Sell";

const PaymentStatus = ({ match }) => {
  const sessionID = match.params.sessionid ? match.params.sessionid : false;
  const storeID = match.params.storeid ? match.params.storeid : false;
  // const [form] = Form.useForm();
  const dispatch = useDispatch();
  var openedWindow; //Global var to store a reference for closing the window

  const getReduxPaymentWindowClose = useSelector(
    ({ commonConfigs }) => commonConfigs.statusPaymentWindowClose
  );

  const [getSelectedOutlet, setSelectedOutlet] = React.useState("");
  const [getIsMounted, setIsMounted] = React.useState(true);

  function openWindow() {
    openedWindow = window.open(
      `payment/status/${storeID}/${sessionID}`,
      "_self"
    );
  }

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (sessionID) {
        getPaymentStatus(storeID, sessionID, mounted);
      }
      //for closing window (only those window close by js which is opened by js)
      if (localStorage.getItem("openwindow") == "1") {
        localStorage.setItem("openwindow", "0");
        openWindow();
      }
    }

    return () => {
      mounted = false;
      setIsMounted(false);
    };
  }, []);

  //for closing window at the end
  React.useEffect(() => {
    let mounted = true;
    if (getReduxPaymentWindowClose && mounted) {
      dispatch(loadPaymentCloseWindow(false));
      // closeOpenedWindow();
      window.close();
    }

    return () => {
      mounted = false;
    };
  }, [getReduxPaymentWindowClose]);

  async function getPaymentStatus(storeid, sessionid, isMounted) {
    const createReq = ds.payRespStatusReqService(storeid, sessionid);
    await createReq
      .then((res) => {
        if (isMounted && getIsMounted) {
          if (res) {
            // if (res.isPaid && res.mode == "2") {
            //   dispatch(loadIsShowCompleteSale(true)); //payment done
            // }
            dispatch(loadPaymentStatusData(res));
            dispatch(loadPaymentStatusModalShow(true));
            // for other page display (new page maintain separate redux value start from initialize value & doesnt render value on prev opened screen)
            let localData = JSON.stringify(res);
            localStorage.setItem("statusresponse", localData);
          }
        }
      })
      .catch((e) => {});
  }

  return (
    <Spin
      tip={"Loading"}
      spinning={true}
      size="large"
      style={{ marginTop: "15%" }}
    >
      <div>
        <PaymentStatusModal />
        <Row style={{ marginTop: "6%" }} justify="center">
          <Col>
            <h1>
              <strong>Payment Status</strong>
            </h1>
          </Col>
        </Row>
        {/* <Spinner style={{ width: '3rem', height: '3rem' }} color="primary" />   */}
      </div>
    </Spin>
  );
};

export default PaymentStatus;
